import { render } from "./ChoosePersonaType.vue?vue&type=template&id=5b4da458"
import script from "./ChoosePersonaType.vue?vue&type=script&lang=js"
export * from "./ChoosePersonaType.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mathieu/www-root/persona-tool/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__